class InputTextModalController {
    constructor() {
        this.$onInit = () => {
            this.init();
        };
        this.init = () => {
            if (this.resolve.initialInputValue) {
                this.inputModel = this.resolve.initialInputValue;
            }
        };
        this.ok = () => {
            // If the user just puts in whitespace we'll get undefined. Switch it to an empty string and let the consumer
            // handle it
            if (angular.isUndefined(this.inputModel)) {
                this.inputModel = '';
            }
            this.close({ $value: this.inputModel });
        };
        this.cancel = () => {
            this.dismiss();
        };
    }
}
angular.module('app').component('inputTextModal', {
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    },
    templateUrl: 'scripts/app/components/input-text-modal/input-text-modal.tpl.html',
    controllerAs: 'vm',
    controller: InputTextModalController
});
